import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import CookieBanner from './components/CookieBanner';
import { CgvGateProvider } from './components/CgvGate';

// Public Pages
import HomePage from './pages/HomePage';
import AProposPage from './pages/AProposPage';
import PersonnalisationPage from './pages/PersonnalisationPage';
import ConseilsPage from './pages/ConseilsPage';
import ArticlePage from './pages/ArticlePage';
import AvisPage from './pages/AvisPage';
import ContactPage from './pages/ContactPage';
import RendezVousPage from './pages/RendezVousPage';
import FaqPage from './pages/FaqPage';
import EvenementsPage from './pages/EvenementsPage';
import LivraisonPage from './pages/LivraisonPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import ConfidentialitePage from './pages/ConfidentialitePage';
import BoutiquePage from './pages/BoutiquePage';
import BoutiqueHubPage from './pages/BoutiqueHubPage';
import ScrollToTop from './components/ScrollToTop';
import CgvPage from './pages/CgvPage';
import CoachingPage from './pages/CoachingPage';
import CartePage from './pages/CartePage';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPerfumes from './pages/admin/AdminPerfumes';
import AdminNews from './pages/admin/AdminNews';
import AdminAppointments from './pages/admin/AdminAppointments';
import AdminGiftCards from './pages/admin/AdminGiftCards';
import AdminCoachingWaitlist from './pages/admin/AdminCoachingWaitlist';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminArticles from './pages/admin/AdminArticles';
import AdminDiagnostics from './pages/admin/AdminDiagnostics';
import AdminLoyalty from './pages/admin/AdminLoyalty';
import FidelitePage from './pages/FidelitePage';
import MonSoldePage from './pages/MonSoldePage';
import UniversPage from './pages/UniversPage';
import { CartProvider } from './context/CartContext';
import { CartPage, CheckoutPage, OrderConfirmationPage } from './pages/CartCheckoutPages';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <CgvGateProvider>
        <CartProvider>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route
              path="/*"
              element={
                <>
                  <Navigation />
                  <div className="pt-20">
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/qui-sommes-nous" element={<AProposPage />} />
                      <Route path="/abonnement" element={<Navigate to="/boutique/abonnement" replace />} />
                      <Route path="/catalogue" element={<Navigate to="/boutique/fragrances" replace />} />
                      <Route path="/personnalisation" element={<PersonnalisationPage />} />
                      <Route path="/conseils" element={<ConseilsPage />} />
                      <Route path="/conseils/:slug" element={<ArticlePage />} />
                      <Route path="/avis" element={<AvisPage />} />
                      <Route path="/contact" element={<ContactPage />} />
                      <Route path="/rendez-vous" element={<RendezVousPage />} />
                      <Route path="/faq" element={<FaqPage />} />
                      <Route path="/evenements" element={<EvenementsPage />} />
                      <Route path="/livraison" element={<LivraisonPage />} />
                      <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
                      <Route path="/cgv" element={<CgvPage />} />
                      <Route path="/confidentialite" element={<ConfidentialitePage />} />
                      <Route path="/boutique" element={<BoutiqueHubPage />} />
                      <Route path="/boutique/:slug" element={<BoutiquePage />} />
                      <Route path="/coaching" element={<CoachingPage />} />
                      <Route path="/carte" element={<CartePage />} />
                      <Route path="/fidelite" element={<FidelitePage />} />
                      <Route path="/mon-solde" element={<MonSoldePage />} />
                      <Route path="/univers" element={<UniversPage />} />
                      <Route path="/panier" element={<CartPage />} />
                      <Route path="/checkout" element={<CheckoutPage />} />
                      <Route path="/commande/:id" element={<OrderConfirmationPage />} />
                    </Routes>
                  </div>
                  <Footer />
                </>
              }
            />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route path="/" element={<AdminDashboard />} />
                    <Route path="/perfumes" element={<AdminPerfumes />} />
                    <Route path="/news" element={<AdminNews />} />
                    <Route path="/appointments" element={<AdminAppointments />} />
                    <Route path="/gift-cards" element={<AdminGiftCards />} />
                    <Route path="/coaching-waitlist" element={<AdminCoachingWaitlist />} />
                    <Route path="/testimonials" element={<AdminTestimonials />} />
                    <Route path="/articles" element={<AdminArticles />} />
                    <Route path="/diagnostics" element={<AdminDiagnostics />} />
                    <Route path="/loyalty" element={<AdminLoyalty />} />
                  </Routes>
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster />
          <CookieBanner />
        </div>
        </CartProvider>
        </CgvGateProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
